// One-time welcome message for a first-time visitor. Registered as
// Alpine.data('welcomePopup').
//
// It waits for the cookie banner to be gone: two dialogs stacked on top of each
// other is the fastest way to get both of them dismissed unread.
export default function registerWelcomePopup(Alpine) {
    Alpine.data('welcomePopup', (cookieName = 'welcome_seen', days = 365) => ({
        open: false,

        init() {
            if (window.getCookie(cookieName)) {
                return;
            }

            if (this.consentGiven()) {
                this.$nextTick(() => (this.open = true));

                return;
            }

            this.onConsent = () => {
                if (! window.getCookie(cookieName)) {
                    this.openWhenScrollingIsFree();
                }

                window.removeEventListener('consent-changed', this.onConsent);
            };

            window.addEventListener('consent-changed', this.onConsent);
        },

        destroy() {
            if (this.onConsent) {
                window.removeEventListener('consent-changed', this.onConsent);
            }
        },

        consentGiven() {
            const config = document.getElementById('cc-config');

            if (! config) {
                return true;
            }

            try {
                return Boolean(window.getCookie(JSON.parse(config.textContent).cookieName));
            } catch (error) {
                return true;
            }
        },

        // Both dialogs lock scrolling through x-trap.noscroll, and that lock is not
        // reference counted: opening this one while the cookie banner is still tearing
        // its lock down means this one saves "overflow: hidden" as the state to restore.
        // Closing it then puts the lock back and the visitor cannot scroll, which is
        // only obvious on a phone where there is no scrollbar to notice. So wait until
        // the page scrolls again, with a cap so a stuck lock can never keep the welcome
        // message hidden altogether.
        openWhenScrollingIsFree(attempt = 0) {
            if (document.documentElement.style.overflow === 'hidden' && attempt < 120) {
                window.requestAnimationFrame(() => this.openWhenScrollingIsFree(attempt + 1));

                return;
            }

            this.open = true;
        },

        close() {
            this.open = false;
            window.setCookie(cookieName, '1', days);
        },
    }));
}
